import FridgesPage from "../components/FridgesPage";

export default function EcoControlFridges() {
  return <FridgesPage />;
}

